<div class="confirmation">
    <div class="confirmation__inner" [ngClass]="{'-center': center}">
        <shared-indicator class="confirmation__indicator" [feel]="feel" [size]="size" [icon]="icon"></shared-indicator>

        <shared-header class="confirmation__hd" *ngIf="type !== null" [type]="type" [marginBottom]="marginBottom"
            [marginTop]="marginTop" [inverted]="inverted" [center]="center">
            <ng-content></ng-content>
        </shared-header>

    </div>
</div>